/**
 * How a highlight that marks what you picked goes away: it holds, then fades.
 * One pair for every such highlight — the 3D viewer's selection pink and
 * "Show me" flash (`components/3d/utils/highlightUtils`, which re-exports
 * these) and the floor plan's selected-room fill (`UVFloorPlanCanvas` /
 * `useFloorplanRenderer`) — so they all go the same way. The floor plan's and
 * the elevations' element highlights do not fade at all: on a drawing they
 * cover nothing, and they are how you see what is selected.
 */
export const HIGHLIGHT_FADE_DELAY_MS = 2000;
export const HIGHLIGHT_FADE_DURATION_MS = 500;

/** The highlight's strength, 1 down to 0, `elapsedMs` after it was painted. */
export function highlightFadeAlpha(elapsedMs) {
  if (elapsedMs <= HIGHLIGHT_FADE_DELAY_MS) return 1;
  return Math.max(
    0,
    1 - (elapsedMs - HIGHLIGHT_FADE_DELAY_MS) / HIGHLIGHT_FADE_DURATION_MS
  );
}
